import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Loader} from 'semantic-ui-react';
import {shortDate} from '../../../../common/constants/datesFormat';

class BilledOrders extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  renderOrdersDetail() {
    const {orders} = this.props;

    return orders.map((order, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{order.invoice}</Table.Cell>
          <Table.Cell textAlign='right'>{order.quantity}</Table.Cell>
          <Table.Cell textAlign='right'>{order.available}</Table.Cell>
          <Table.Cell textAlign='center'>{this.renderDate(order.date)}</Table.Cell>
          <Table.Cell textAlign='center'>{this.renderDate(order.realDate)}</Table.Cell>
          <Table.Cell textAlign='center'>{order.observation || '-'}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderDate(value) {
    return value ? moment(value).format(shortDate) : null;
  }

  getTotal(key) {
    const {orders} = this.props;

    return orders.reduce((total, order) => {
      return total + (order[key] ? parseInt(order[key], 10) : 0);
    }, 0);
  }

  render() {
    const {loading} = this.props;

    if (loading) {
      return (<Loader active inline='centered'>Consultando...</Loader>);
    }

    return (
      <div className='table-scroll-container'>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan='6'>Pedidos Confirmados</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell textAlign='center' className='fixed'>Pedido</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Cantidad</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Disp.</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>ETA Estandar</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>ETA Actualizada</Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='fixed'>Observación</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderOrdersDetail()}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan='6' textAlign='center'>
              Total: {this.getTotal('quantity')} Total disponible: {this.getTotal('available')}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingOnOrdersDetail, onOrdersDetail} = state.partModals;
  const {confirmed = []} = onOrdersDetail;

  return {
    'loading': loadingOnOrdersDetail,
    'orders': confirmed,
  };
};

export default connect(mapStateToProps)(BilledOrders);
